import { cardSrc } from './resultParsers';

const TOTALS = ['Total 0', 'Total 1', 'Total 2', 'Total 3'];
const NUM = 4;

// card value: leading digits (2,3,4,5,6); Queen/non-numeric = 0
function cardVal(code) {
  const m = String(code).match(/^(\d+)/);
  return m ? parseInt(m[1], 10) : 0;
}

// round-robin: Total t gets card indices t, t+4, t+8, ... (skip facedown '1')
function getTotalCards(codes, t) {
  const cards = [];
  for (let i = t; i < codes.length; i += NUM) {
    const c = codes[i];
    if (c && c !== '1' && c !== '0') cards.push(c);
  }
  return cards;
}

export default function QueenResult({ detail }) {
  const codes = (detail?.card || '').split(',').map((s) => s.trim());
  const totalCards = TOTALS.map((_, i) => getTotalCards(codes, i));
  // score = card-values-sum + Total-index (Total N N points se start)
  const scores = totalCards.map((cards, i) => cards.reduce((s, c) => s + cardVal(c), 0) + i);

  const winnat = detail?.winnat || '';
  const winValue = detail?.win;
  let winnerIdx = -1;
  if (winnat) winnerIdx = TOTALS.findIndex((t) => winnat.includes(t));
  if (winnerIdx < 0 && winValue != null && winValue !== '') winnerIdx = Number(winValue) - 1;

  return (
    <div className="row row5 card32result">
      <div className="col-12 col-lg-8">
        <div className="row row5">
          {TOTALS.map((name, i) => {
            // A lane with no card dealt is not shown, like the reference (user 2026-10-19).
            if (!totalCards[i].length) return null;
            const isWinner = i === winnerIdx;
            return (
              <div key={i} className="col-12 col-lg-12">
                <div className="casino-result-cards">
                  <h4 className="text-center d-inline-block">
                    {name} -
                    {' '}
                    <span className="badge badge-success font14">{scores[i]}</span>
                  </h4>
                  {' '}
                  {totalCards[i].map((code, j) => (
                    <div key={j} className="casino-result-cards-item">
                      <img src={cardSrc(code)} alt={code} />
                    </div>
                  ))}
                  {isWinner && (
                    <>
                      {' '}
                      <div className="casino-result-cards-item">
                        <img src="https://wver.sprintstaticdata.com/v230/static/front/img/winner.png" className="winner-icon" alt="Winner" />
                      </div>
                    </>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="col-12 col-lg-4">
        <div className="casino-result-desc">
          <div className="casino-result-desc-item">
            <div>Winner</div>
            <div>{winnat || (winnerIdx >= 0 ? TOTALS[winnerIdx] : '')}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
